import { sva } from "@agapi/ui/panda/css";

export const productCardStyles = sva({
  slots: ['root', 'image', 'header', 'brandName', 'title', 'content', 'price', 'originalPrice', 'campaignPrice', 'footer'],
  base: {
    root: {
      height: '100%',
      overflow: 'visible!',
      width: '100%',
    },
    image: {
      width: "auto",
      maxHeight: '100%',
      objectFit: 'contain',
      backgroundSize: 'contain!',
      backgroundPosition: 'center',
      aspectRatio: '1/1!'
    },
    header: {
      gap: '3',
      px: '0!'
    },
    brandName: {
      fontSize: 'sm',
      color: 'text.subdued'
    },
    title: {
      textStyle: 'h6',
      lineHeight: 'none',
      whiteSpace: 'normal',
      color: 'text.heading'
    },
    content: {
      display: 'flex',
      flexDir: 'row',
      alignItems: 'flex-end',
      gap: '2',
      px: '0!'
    },
    originalPrice: {
      fontFamily: 'body',
      fontSize: 'md',
      fontWeight: '400',
      textDecoration: 'line-through',
      color: 'text.subdued'
    },
    campaignPrice: {
      fontFamily: 'body',
      fontWeight: '900',
      color: 'commerce.campaign.text',
    },
    price: {
      fontFamily: 'body',
      color: 'text.vibrant',
      fontWeight: '900',
    },
    footer: {
      px: '0!'
    }
  },
  variants: {
    size: {
      small: {
        root: {
          minWidth: { base: '100%', md: '400px' },
          flexDir: 'row',
          overflow: 'visible!'
        },
        title: {
          textStyle: 'body',
          fontWeight: 'bold',
          fontSize: 'md',
          color: 'text.heading'
        },
        footer: {
          display: 'flex',
          flexDir: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          flex: 1
        },
        price: {
          fontWeight: '900',
          color: 'text.vibrant',
          fontSize: 'md',
        },
      }
    }
  }
});
